import React from "react";

import type { DefaultComponent, LoadableComponent } from "@loadable/component";
import loadable from "@loadable/component";

import { ErrorBoundary } from "../ErrorBoundary";

/**
 * Loadable helper for optional components with some defaults configured
 * Note: Make sure to import this as "loadable" for their babel plugin to process
 * this correctly for dynamic code-splitting
 * @param loader
 */
export function loadableOptionalComponent<T extends {}>(
  loader: (props: T) => Promise<DefaultComponent<T>>
): LoadableComponent<T> {
  const LazyLoadedComponent = loadable(loader);

  return Object.assign(
    (props: T) => (
      <ErrorBoundary renderError={() => null}>
        {() => <LazyLoadedComponent {...props} />}
      </ErrorBoundary>
    ),
    {
      preload: LazyLoadedComponent.preload.bind(LazyLoadedComponent),
      load: LazyLoadedComponent.load.bind(LazyLoadedComponent),
    }
  );
}
